// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__302L8","title":"styles_title__JPY_E"};